import { useCallback } from 'react';
import { useRemoveDisplayWebContent } from '../state/actions/useRemoveDisplayWebContent';
import { useWorkFlowCanvas } from '../../../../contexts/CampaignFlowProvider';
import { Canvas } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Canvas';

export const useRemoveDisplayWebContentFromWorkflow = () => {
  const { dispatch, state } = useWorkFlowCanvas();
  const removeDisplayWebContent = useRemoveDisplayWebContent();

  return useCallback(
    (id: string) => {
      const { nodes, edges } = Canvas.createFromState(state)
        .removeNode(id)
        .convertToState();

      dispatch({
        type: 'UPDATE',
        payload: { nodes, edges },
      });

      removeDisplayWebContent(id);
    },
    [dispatch, removeDisplayWebContent, state],
  );
};
